import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/OrganizationTab/index.js